<template>
    <modal id="create-space-modal" class="fix" size="xl">
        <template slot="title">Add Space</template>
        <template slot="body">
            <div class="inputs">
                <field-input v-model="form.building" placeholder="Building Number"></field-input>
                <field-input v-model="form.floor" placeholder="Floor Number"></field-input>
                <field-input v-model="form.name" placeholder="Space Name"></field-input>
                <field-select v-model="form.type" placeholder="Space Type">
                    <option v-for="type in spaceTypes" :value="type.id" v-text="type.label"></option>
                </field-select>
                <div class="form-group">
                    <label for="forms" class="mb-2">Available Forms:</label>
                    <!--div style="height: 300px; overflow-y: scroll" -->
                        <table class="table table-sm">
                            <tr v-for="form in forms">
                                <td>
                                    <div class="text-muted" v-text="form.name"></div>
                                    <div class="text-info text-sm" v-text="`${form.group.code} - ${form.group.name}`"></div>
                                </td>
                                <td>
                                    <div class="d-flex">

                                        <button @click.prevent="addForm(form)" class="btn btn-sm btn-default border">
                                            <i class="fa fa-plus ml-1"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    <!--/div-->
                </div>
            </div>
            <div class="w-100">
                <div class="p-4">
                    <p>Tests</p>
                    <table class="table table-sm table-striped">
                        <tr v-for="(_form, index) in form.forms">
                            <td>
                                <div v-text="_form.name"></div>
                                <div class="text-info text-sm" v-text="_form.group.code"></div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end">
                                    <button @click.prevent="removeForm(_form, index)" class="btn btn-sm btn-default border ml-auto">
                                        <i class="fa fa-times ml-1"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

        </template>
        <template slot="footer">
            <button class="btn btn-default" type="button" @click="closeModal('create-space-modal')">Close</button>
            <button class="btn btn-success" type="button" @click="save()">Save</button>
        </template>
    </modal>
</template>
<script>

let SpaceTypes = require('@/mixins/SpaceTypes')

    export default {

        mixins: [SpaceTypes],

        props: {
            project:{
                type: Object,
                required: true,
            },
            forms:{
                type: Array,
                required: true,
            }
        },

        data(){
            return {
                form: null,
            }
        },

        created () {
            this.loadForm();
        },

        methods: {

            save() {
                if (this.validate()) {
                    this.form.post(`/projects/${this.project.slug}/spaces`).then(response => {
                        Toast.success(`Space ${response.space.name} is in your dashboard!`)
                        App.bus.$emit('refresh-space-areas', response)
                        this.loadForm();
                        this.closeModal('create-space-modal')
                    }).catch(error => {
                        Alert.error(error.first());
                    })
                }
            },


            addForm(form){
                // this.validate()
                this.form.forms.push(form)
            },

            removeForm(form, index){
                this.form.forms.splice(index, 1);
            },

            validate() {

                // Only admins can add all test's.
                if (this.authorize('admin')) {
                    return true;
                }

                if (this.project.version == 2019) {

                    var nrca_lti_05_A = [25, 26];

                    if (this.form.forms.includes(nrca_lti_05_A[0]) && this.form.forms.includes(nrca_lti_05_A[1])) {
                        Alert.error('You only can select one of the NRCA-LTI-05-A forms')
                        return false;
                    }
                }

                return true;
            },

            loadForm(){
                this.form = new Form({
                    building: '',
                    floor: '',
                    name: '',
                    type: 'office',
                    forms: [],
                });
                this.lastSpaceInformation();
            },

            lastSpaceInformation () {
                axios.post(`/projects/${this.project.slug}/spaces/last`).then(response => {
                    this.form.building = response.data.building;
                    this.form.floor = response.data.floor;
                })
            },
        },
    }
</script>
